export default window?.msi;
